export const MODULE_SHOW_RESET = 'MODULE_SHOW_RESET'
export const MODULE_SHOW_SET_ERROR = 'MODULE_SHOW_SET_ERROR'
export const MODULE_SHOW_SET_RETRIEVED = 'MODULE_SHOW_SET_RETRIEVED'
export const MODULE_SHOW_TOGGLE_LOADING = 'MODULE_SHOW_TOGGLE_LOADING'
